<div class="flex flex-col md:flex-row justify-center gap-6 items-start mt-4 w-full px-4 xl:px-8">
  <div class="md:w-64 w-full flex-shrink-0">
    <app-filters-sidebar [isFirstLoad]="isFirstLoad" [isLoading]="isFiltering">
      <!-- Years -->
      <div
        class="py-3 px-3 font-bold border-b border-gray-200 text-gray-700 bg-gray-50 text-base tracking-wide"
      >
        Publication year
      </div>
      <div class="py-3 px-3 flex flex-col gap-2 bg-white">
        <button
          type="button"
          class="rounded text-left text-sm leading-tight hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
          [ngClass]="activeFilter === 'any' ? 'font-bold text-red-700' : 'text-blue-600'"
          (click)="applyScholarFilter('any')"
        >
          Any time
        </button>
        <button
          type="button"
          class="rounded text-left text-sm leading-tight hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
          [ngClass]="activeFilter === 'year0' ? 'font-bold text-red-700' : 'text-blue-600'"
          (click)="applyScholarFilter('year0')"
        >
          Since {{ currentYear }}
        </button>
        <button
          type="button"
          class="rounded text-left text-sm leading-tight hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
          [ngClass]="activeFilter === 'year1' ? 'font-bold text-red-700' : 'text-blue-600'"
          (click)="applyScholarFilter('year1')"
        >
          Since {{ currentYear - 1 }}
        </button>
        <button
          type="button"
          class="rounded text-left text-sm leading-tight hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
          [ngClass]="activeFilter === 'year2' ? 'font-bold text-red-700' : 'text-blue-600'"
          (click)="applyScholarFilter('year2')"
        >
          Since {{ currentYear - 2 }}
        </button>
        <button
          type="button"
          class="rounded text-left text-sm leading-tight hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
          [ngClass]="activeFilter === 'custom' ? 'font-bold text-red-700' : 'text-blue-600'"
          (click)="applyScholarFilter('custom')"
        >
          Custom range...
        </button>

        <div
          *ngIf="showCustomRange"
          class="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-2 w-full box-border"
        >
          <div class="flex justify-between items-center w-full gap-2">
            <label class="sr-only" for="startYear">Start year</label>
            <input
              id="startYear"
              type="number"
              [(ngModel)]="startYear"
              [min]="minAvailableYear"
              [max]="endYear"
              class="flex-1 w-full min-w-0 rounded-md border-gray-300 bg-white px-2 py-1.5 text-center text-sm text-gray-800 focus:border-purple-600 focus:ring-purple-600"
            />
            <span class="font-medium text-gray-500" aria-hidden="true">-</span>
            <label class="sr-only" for="endYear">End year</label>
            <input
              id="endYear"
              type="number"
              [(ngModel)]="endYear"
              [min]="startYear"
              [max]="maxAvailableYear"
              class="flex-1 w-full min-w-0 rounded-md border-gray-300 bg-white px-2 py-1.5 text-center text-sm text-gray-800 focus:border-purple-600 focus:ring-purple-600"
            />
          </div>
          <div class="overflow-x-hidden px-1 w-full relative z-10">
            <mat-slider
              class="publication-range-slider mt-1 w-full"
              [min]="minAvailableYear"
              [max]="maxAvailableYear"
            >
              <input [(ngModel)]="startYear" matSliderStartThumb aria-label="Start year" />
              <input [(ngModel)]="endYear" matSliderEndThumb aria-label="End year" />
            </mat-slider>
          </div>
          <div class="-mt-4 flex justify-between px-4 text-xs font-bold text-gray-500 w-full">
            <span>{{ minAvailableYear }}</span>
            <span>{{ maxAvailableYear }}</span>
          </div>
          <button
            type="button"
            (click)="applyCustomRange()"
            class="mt-3 block w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-bold tracking-wider text-purple-700 hover:border-purple-400 hover:bg-purple-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600"
          >
            Search
          </button>
          <div
            *ngIf="appliedStartYear !== null && appliedEndYear !== null"
            class="mt-2 flex items-center justify-center gap-1 rounded-md bg-purple-50 border border-purple-200 px-2 py-1.5 text-xs text-purple-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="font-semibold"
              >Applied: {{ appliedStartYear }} – {{ appliedEndYear }}</span
            >
          </div>
        </div>
      </div>
    </app-filters-sidebar>
  </div>
  <div class="flex-1 w-full flex flex-col">
    <!-- Tarjeta QA (estilo overview): arriba, delgada; se oculta si falla -->
    <section class="qa-overview-card mb-3 w-full" *ngIf="showQaCard" aria-live="polite">
      <div class="qa-overview-inner">
        <div class="qa-overview-header">
          <span class="qa-overview-label">{{ qaLoading ? 'Generating' : 'Q&A overview' }}</span>
          <span class="qa-overview-dots" *ngIf="qaLoading" aria-hidden="true">
            <span></span><span></span><span></span>
          </span>
        </div>

        <div class="qa-skeleton" *ngIf="qaLoading">
          <div class="qa-skeleton-line w-full"></div>
          <div class="qa-skeleton-line w-11/12"></div>
          <div class="qa-skeleton-line w-4/5"></div>
          <div class="qa-skeleton-line w-2/3"></div>
        </div>

        <ul class="qa-pairs" *ngIf="!qaLoading && qaPairs.length > 0">
          <li *ngFor="let pair of qaPairs; let i = index">
            <p class="qa-question">{{ i + 1 }}. {{ pair.question }}</p>
            <p class="qa-answer">{{ pair.answer }}</p>
          </li>
        </ul>
      </div>
    </section>

    <ng-container *ngIf="{ data: articles$ | async } as obs">
      <ng-container *ngIf="!(isFirstLoad || isFiltering || isPaginating); else loadingTpl">
        <div class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden w-full">
          <div *ngIf="obs.data as response">
            <table
              mat-table
              [dataSource]="response.data"
              matSort
              matSortActive="publication_date"
              matSortDisableClear
              matSortDirection="desc"
            >
              <!-- Title Column -->
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef>Title</th>
                <td mat-cell *matCellDef="let row">{{ row.title }}</td>
              </ng-container>

              <!-- Author Count Column -->
              <ng-container matColumnDef="author_count">
                <th mat-header-cell *matHeaderCellDef>Authors</th>
                <td mat-cell *matCellDef="let row">{{ row.author_count }}</td>
              </ng-container>

              <!-- Affiliation Count Column -->
              <ng-container matColumnDef="affiliation_count">
                <th mat-header-cell *matHeaderCellDef>Affiliations</th>
                <td mat-cell *matCellDef="let row">{{ row.affiliation_count }}</td>
              </ng-container>

              <!-- Publication Date Column -->
              <ng-container matColumnDef="publication_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
                  Publication Date
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.publication_date | date }}
                </td>
              </ng-container>

              <!-- Add this after the publication_date column -->
              <ng-container matColumnDef="relevance">
                <th mat-header-cell *matHeaderCellDef>Relevance Score</th>
                <td mat-cell *matCellDef="let row">{{ row.relevance?.toFixed(4) || 'N/A' }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="clickedRows(row)"
                class="hover:cursor-pointer hover:bg-gray-200"
              ></tr>
            </table>
          </div>
        </div>
      </ng-container>
      <ng-template #loadingTpl>
        <div class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden w-full">
          <app-loader [rows]="10"></app-loader>
        </div>
      </ng-template>

      <div
        class="flex flex-col sm:flex-row items-center justify-end px-4 py-2 bg-white mt-4 rounded-xl shadow-md border border-gray-200"
        *ngIf="total > 0"
      >
        <div class="text-sm text-gray-600 font-medium mr-4 flex items-center">
          <app-mini-loader *ngIf="isPaginating" class="mr-2"></app-mini-loader>
          Current Page: <span class="text-red-700 font-bold ml-1">{{ page }}</span>
        </div>
        <mat-paginator
          [length]="total"
          [pageSize]="size"
          [pageIndex]="page - 1"
          [pageSizeOptions]="[5, 10, 25, 100]"
          aria-label="Select page"
          (page)="onChangePagination($event)"
        >
        </mat-paginator>
      </div>
    </ng-container>
    <ng-container *ngIf="!(isFirstLoad || isFiltering || isPaginating) && total === 0">
      <app-no-results [isServerOnline]="isServerOnline" title="No results found"></app-no-results>
    </ng-container>
  </div>
</div>
